import { useNavigate } from 'react-router-dom'

import type { BreadcrumbProps } from './types'

import * as S from './styles'

export const Breadcrumb = ({ breadcrumbData }: BreadcrumbProps) => {
  const navigate = useNavigate()

  return (
    <S.Container>
      {breadcrumbData.map((item, index) => (
        <S.Content key={item.label} onClick={() => !!item.route && navigate(item.route)}>
          {item.label} {index < breadcrumbData.length - 1 && <S.Arrow>/</S.Arrow>}
        </S.Content>
      ))}
    </S.Container>
  )
}
